import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// @ts-ignore
import TwitterIcon from '../../assets/twitter.png';
// @ts-ignore
import LinkedinIcon from '../../assets/linkedin.png';

const Footer = () => {
  return (
    <Box mt={6} sx={{ px: { xs: 1, sm: 1, md: 0 } }} pb={2}>
      <Box display="flex" borderBottom="1px solid transparent" borderColor="primary.main" pb={1} alignItems="center">
        <Box flex={1}>
          <Typography color="primary.main" fontWeight="600">
            Conectamos Latam
          </Typography>
        </Box>
        <Box flex={1} textAlign="right">
          <a href="https://twitter.com/tapi_latam" target="_blank">
            <img src={TwitterIcon} alt="twitter" width="32px" />
          </a>
          &nbsp;&nbsp;
          <a href="https://www.linkedin.com/company/tapi-latam" target="_blank">
            <img src={LinkedinIcon} alt="linkedin" width="32px" />
          </a>
        </Box>
      </Box>

      <Box display="flex" pt={1}>
        <Box flex={1}>
          <Typography>
            © 2022 Tapi. Todos los derechos reservados.
          </Typography>
        </Box>
        <Box flex={1} textAlign="right">
          <Typography>
            Desarrollo web by <Typography sx={{ textDecoration: 'none' }} component="a" href="https://elevatemarketing.agency/en/home/" target="_blank" color="primary.main">Elevate</Typography>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
